// extracted by mini-css-extract-plugin
export default {"link":"qC-z","disabled":"rC-z"};